import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, BoxProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';


// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, Props>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const theme = useTheme();

    const PRIMARY_LIGHT = theme.palette.primary.light;

    const PRIMARY_MAIN = theme.palette.primary.main;

    const PRIMARY_BG = theme.palette.background.default;

    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          width: 40,
          height: 30,
          display: 'inline-flex',
          ...sx,
        }}
        {...other}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 800 600">
          <defs>
            <linearGradient id="BG1" x1="0%" x2="100%" y1="0%" y2="0%">
              <stop offset="40%" stopColor={PRIMARY_MAIN} />
              <stop offset="40%" stopColor={PRIMARY_LIGHT} />
            </linearGradient>
            <linearGradient id="BG2" x1="0%" x2="100%" y1="0%" y2="0%">
              <stop offset="40%" stopColor={PRIMARY_MAIN} />
              <stop offset="40%" stopColor={PRIMARY_LIGHT} />
            </linearGradient>
          </defs>
          <g>
            <path
              stroke={PRIMARY_MAIN}
              fill={PRIMARY_MAIN}
              d="M100,100 L175,425 625,500,700,100 Z"
              strokeLinejoin="round"
              strokeWidth="150"
            />

            <path
              d="M120,115 L190,410 610,480,680,115 Z"
              strokeLinejoin="round"
              fill={PRIMARY_BG}
              stroke={PRIMARY_BG}
              strokeWidth="100"
            />
            <path
              fill={PRIMARY_MAIN}
              stroke={PRIMARY_MAIN}
              d="M120,115 L175,410 280,290 z"
              strokeLinejoin="round"
              strokeWidth="101"
            />
            <path
              fill={PRIMARY_LIGHT}
              stroke={PRIMARY_LIGHT}
              d="M120,115 L190,410 330,434,480,290,290,115 Z"
              strokeLinejoin="round"
              strokeWidth="100"
            />
            <path
              fill={PRIMARY_LIGHT}
              stroke={PRIMARY_LIGHT}
              d="M120,115 L190,410 250,420,380,290,200,115 Z"
              strokeLinejoin="round"
              strokeWidth="90"
            />
            <path
              fill={PRIMARY_MAIN}
              stroke={PRIMARY_MAIN}
              d="M120,115 L175,410 280,290 z"
              strokeLinejoin="round"
              strokeWidth="110"
            />
          </g>
        </svg>
      </Box>
    );

    if (disabledLink) {
      return <>{logo}</>;
    }

    return <RouterLink to="/">{logo}</RouterLink>;
  }
);

export default Logo;


